module.exports = __webpack_public_path__ + "media/src/img/payment/tinkoff-logo-ea3939ecc35bb37d047d67a6e3a4304a.svg";